import { HStack, Box } from '@cad-arc';
import { EventSearchOptions } from '@mark43/cad-api';
import { UseFormReturn } from 'react-hook-form';
import { FormDateRange } from '../forms/integrated-form-controls/form-date-range';
import { FormSelect } from '../forms/integrated-form-controls/form-select';
import { EventSearchFormType } from './types';
import { INPUT_WIDTH_SM } from '../search-windows/constants';
import { useHandleFormDateRange } from '../common/hooks/use-handle-form-date-range';

export function EventSearchFormTimeRangeFields({
    form,
    options,
}: {
    form: UseFormReturn<EventSearchFormType>;
    options: EventSearchOptions;
}) {
    const { showDateRangeInput } = useHandleFormDateRange({
        timeRangeOptionPath: 'timeRangeOption',
        dateRangePath: 'dateRange',
    });

    return (
        <HStack gap="4px" alignItems="flex-start">
            <Box w={INPUT_WIDTH_SM}>
                <FormSelect
                    name="timeRangeOption"
                    label="Time Range"
                    control={form.control}
                    options={options.timeRangeOptions}
                    isClearable={false}
                />
            </Box>
            {showDateRangeInput && (
                <Box marginTop="-4px !important">
                    <FormDateRange
                        name="dateRange"
                        control={form.control}
                        dateRangeProps={{
                            hasCalendar: true,
                            startFormControlProps: { label: 'From' },
                            endFormControlProps: { label: 'To' },
                            granularity: 'minute',
                            hideTimeZone: true,
                            hourCycle: 24,
                        }}
                        rules={{ required: 'Required' }}
                    />
                </Box>
            )}
        </HStack>
    );
}
